import { renderPrice } from '@dna/utils'

class DNAPrice extends HTMLElement {
  connectedCallback() {
    this.initialPrice = this.getAttribute('data-price')
    this.priceElement = this.querySelector('.js-price')
    this.priceRegularElement = this.querySelector('.js-price__regular')
    this.priceSaleElement = this.querySelector('.js-price__sale')
    this.priceItemRegularElement = this.querySelector('.js-price-item--regular')
    this.priceItemSaleElement = this.querySelector('.js-price-item--sale')
    this.priceItemCompareElement = this.querySelector('.js-price-item--compare')
    this.priceUnitWrapperElement = this.querySelector('.js-price__unit-wrapper')
    this.priceItemUnitElement = this.querySelector('.js-price-item--unit')
    this.priceUnitReferenceElement = this.querySelector(
      '.js-price__unit-reference',
    )

    this._setConstructorPrice(this.initialPrice)
  }

  _updatePrice(price, element) {
    let renderedPrice = ''
    if (Number.isFinite(price)) {
      renderedPrice = renderPrice(price)
      element.textContent = renderedPrice
    }
  }

  _setConstructorPrice(price) {
    this.setAttribute(
      'data-cnstrc-item-price',
      renderPrice(price, {
        includeCurrencySymbol: false,
        convertToUSD: true,
      }),
    )
  }

  updatePrices(priceRegular, compareAtPrice) {
    // For price display
    this._updatePrice(priceRegular, this.priceItemRegularElement)
    this._updatePrice(priceRegular, this.priceItemSaleElement)
    this._updatePrice(compareAtPrice, this.priceItemCompareElement)

    if (compareAtPrice > priceRegular) {
      this.priceElement.classList.add('price--on-sale')
    } else {
      this.priceElement.classList.remove('price--on-sale')
    }

    // For Constructor
    this._setConstructorPrice(priceRegular)
  }
}

customElements.define('dna-price', DNAPrice)
